module.exports = __webpack_public_path__ + "static/carbon-table-selected-rows-9b08de14d7a423621a8af50383fad816.png";